module.exports = __webpack_public_path__ + "static/media/horse-neighing.9924ed03.gif";